import script from "./ProfileDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileDropdown.vue?vue&type=script&setup=true&lang=js"

import "./ProfileDropdown.vue?vue&type=style&index=0&id=bdf83804&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdf83804"]])

export default __exports__